import { Model, TranslatedString } from '../types';

export class Specification implements Model {
  id!: string;
  name!: TranslatedString;
  normalizedName!: TranslatedString;
  url!: TranslatedString;
  productType?: string;
}
